<template>
  <div class="QuotationTemplate padding7" v-title data-title="水产价格测算工具">
    <div class="row align-self-center">
      <div v-for="tpl in tpls" :key="tpl.key"
        class="tpl-item col-12 padding5"
        :class="selectedTpl===tpl.value?'active':''"
        @click="clickTplAction(tpl)">
        <!-- <Quotation :item="info" :template="tpl.value" pageType="bill"></Quotation> -->
        <img class="tpl-img" :src="fileDomain+tpl.url">
        <div>{{tpl.title}}</div>
      </div>
    </div>
    <div class="row justify-content-around mt10 pb10">
      <van-button v-if="token" @click="back" type="info" class="btn-common col-6" plain>返回</van-button>
      <van-button @click="previewImage" type="info" class="btn-common col-8">预览模板</van-button>
      <van-button @click="confirm" type="info" class="btn-common col-8">开始制作</van-button>
    </div>
    <!-- 图片预览弹框 -->
    <van-popup
      v-model="previewShow"
      position="bottom"
    >
      <div class="pb10 pl2 pr2">
        <van-image
          width="100%"
          height="calc(100vh - 100px)"
          fit="contain"
          :src="priviewQrcodeUrl"
        >
          <template v-slot:loading>
            图片加载中<van-loading type="spinner" size="20" />
          </template>
        </van-image>
        <div class="row justify-content-around mt7">
          <van-button @click="previewImage('')" type="info" class="btn-common" plain>关闭预览</van-button>
          <!-- <van-button @click="selectTpl" type="info" class="btn-common">选择模板</van-button> -->
        </div>
        <!-- <van-icon class="mt7"
          @click="previewImage('')"
          :size="36" color="#fff" name="close" /> -->
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import wx from 'weixin-js-sdk';
import config from '../../config';
import storage from '../../uitls/cacheUtil';
// import Quotation from '../../components/Quotation.vue';
import promisify from '../../uitls/promisify';
import { sendRequest, getWxParams } from '../../network/NetworkAccessor';
import { isQYWeixin, isWeixin } from '../../uitls/checkUtil';

const shareImage = `${window.location.protocol}//${window.location.host}/images/share/important-notice.png`;

export default Vue.extend({
  name: 'QuotationTemplate',
  components: { },
  data() {
    return {
      isWeixin: isWeixin(),
      isQYWeixin: isQYWeixin(),
      token: storage.local.get('token'),
      previewShow: false,
      fileDomain: config.FILE_DOMAIN,
      priviewQrcodeUrl: '',
      selectedTpl: 0,
      clickTpl: 0,
      tpls: [
        {
          title: '模板一',
          url: 'images/share/tpl_1.png',
          value: 1,
        },
        {
          title: '模板二',
          url: 'images/share/tpl_2.png',
          value: 2,
        },
        {
          title: '模板三',
          url: 'images/share/tpl_3.png',
          value: 3,
        },
      ],
      info: {
        name: '胡露水产',
        customer: '',
        unitText: '',
        address: '湖北省监利',
        mainProducts: '虾',
        quotes: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
        priceType: '发货价',
        mobileList: [
          { name: '胡', mobile: '13500000000' },
        ],
      },
    };
  },
  props: {
  },
  methods: {
    clickTplAction(tpl) {
      const { url = '', value = 0 } = tpl;
      this.clickTpl = value || 0;
      this.priviewQrcodeUrl = url.includes('http') ? url : `${this.fileDomain}${url}`;
      this.selectedTpl = this.clickTpl;
    },
    previewImage(tpl = {}) {
      if (!this.selectedTpl) {
        this.$dialog.alert({
          message: '请先选择一个模板',
        });
        return;
      }
      this.previewShow = !this.previewShow;
      // const { url = '', value = 0 } = tpl;
      // this.priviewQrcodeUrl = url.includes('http') ? url : `${this.fileDomain}${url}`;
      // this.clickTpl = value || 0;
    },
    selectTpl() {
      this.previewShow = !this.previewShow;
      this.selectedTpl = this.clickTpl;
    },
    confirm() {
      if (!this.selectedTpl) {
        this.$dialog.alert({
          message: '请先选择一个模板',
        });
        return;
      }
      this.$router.push(`/quotation/posteredit/${this.selectedTpl}`);
    },
    back() {
      this.$router.replace('/home');
    },
    configWx() {
      if (wx) {
        // const wxp = this.$cookies.get('q_wx_p') || '{}';
        sendRequest(getWxParams, {
          url: window.location.href,
          source: this.isQYWeixin ? 'qywx' : 'wx',
        }).then((res) => {
          console.log(res, 'res');
          return res || {};
        }).catch((error) => {
          console.log(error, 'error');
          return {};
        }).then((info = {}) => {
          wx.config({
            // debug: storage.local.get('type') === 4, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: info.appId, // 必填，公众号的唯一标识
            timestamp: info.timestamp, // 必填，生成签名的时间戳
            nonceStr: info.noncestr, // 必填，生成签名的随机串
            signature: info.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareAppMessage',
              'onMenuShareWechat'], // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            console.log(wx, 'ready==============');
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            const zf = {
              title: '水产销售宣传工具', // 分享标题
              desc: '动动手指制作宣传单，10万人正在使用', // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: `${shareImage}`, // 分享图标
            };
            const pyq = {
              title: '水产销售宣传工具 | 动动手指制作宣传单，10万人正在使用', // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: `${shareImage}`, // 分享图标
            };
            promisify(wx.checkJsApi)({
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            }).then((res) => {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              // 个人微信内转发会话
              promisify(wx.updateAppMessageShareData)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
              // 个人微信内分享朋友圈
              promisify(wx.updateTimelineShareData)(pyq).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
            }).catch((error) => {
              console.log(error, 'error-------');
            });
            promisify(wx.checkJsApi)({
              jsApiList: ['onMenuShareAppMessage',
                'onMenuShareWechat'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            }).then((res) => {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              // 企业微信内转发会话
              promisify(wx.onMenuShareAppMessage)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
              // 企业微信内转发个人微信会话
              promisify(wx.onMenuShareWechat)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
            }).catch((error) => {
              console.log(error, 'error-------');
            });
          });
          wx.error((error) => {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(wx, 'error==============');
          });
        });
      }
    },
  },
  created() {
    this.configWx();
  },
  mounted() {
    this.clickTplAction(this.tpls[0]);
  },
});
</script>
<style scoped>
.QuotationTemplate {
  min-height: 100vh;
}
.tpl-item img {
  width: 100%;
  object-fit: fill;
}
.tpl-item.active {
  border: 2px solid #1989fa;
}
.van-popup {
  background-color: transparent;
  height: 100vh;
  padding-top: 10px;
}
.van-image {
  background-color: #ffffff;
}
</style>
